import {numUtil} from './num';

export function displayLiqPrice(priceEp: number, contract: ContractPair): string {
  const {tickSizeEp, pricePrecision, priceScale} = contract;
  if (priceEp <= tickSizeEp || priceEp >= Math.pow(10, 10)) {
    return '--';
  }
  return numUtil.delimit(numUtil.floor(priceEp, pricePrecision, priceScale));
}
